// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalSource } from './proposalSource.zod.ts';

export const ProposedSection = zod.object({
  "audience": zod.enum(['internal', 'shareable']),
  "body": zod.string(),
  "key": zod.string(),
  "sources": zod.array(ProposalSource),
  "title": zod.string()
});

export type ProposedSection = zod.input<typeof ProposedSection>;
export type ProposedSectionOutput = zod.output<typeof ProposedSection>;
